import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { from, map } from 'rxjs';
import Swal from 'sweetalert2';
import { AlertService } from './alert.service';


@Injectable({ 
    providedIn: 'root'
})

// THE FUNCTION DEFINED HERE IN THESE CAN BE TRIGGERED INDEFINITELY IF ADDED AS {{ fncCall() }} SO MAKE SURE TO PUSH THEM TO HELPER PIPE IF ANY FUNCTION GETS USED MORE OFTEN TO REDUCE LOAD ON CLIENT SIDE FOR PROCESSING

export class HelperService {

    formButtonDisabled: boolean = false;

    constructor(
        private translate: TranslateService,
        private datePipe: DatePipe,
        private http: HttpClient,
        private translateService: TranslateService,
        private alertService: AlertService
    ){}

    actionConfirmation(msg="") {

        const set_msg = msg !== "" ? msg : 'ALERTS.perform-action'; 
        return Swal.fire({
            title: this.translate.instant('COMMON.confirmation'),
            html: `
                <div class='swal-customs-div'>
                    <h5 class='swal-custom-title'>${this.translate.instant('COMMON.are-you-sure')}</h5>
                    <p class='swal-custom-text'>${this.translate.instant(set_msg)}</p>
                </div>`,
            // text: this.translate.instant('COMMON.are-you-sure') + "<br>" + this.translate.instant(set_msg),
            showCancelButton: true,
            cancelButtonText: `${this.translate.instant('COMMON.close')}`,
            confirmButtonText: this.translate.instant('COMMON.proceed'),
            customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'cancel-swal-custom btn btn-secondary'
            },
        }).then(result => {
            return result.isConfirmed;
        });
    }

    deleteRecord(): Promise<boolean> {
        return Swal.fire({
          title: this.translate.instant('COMMON.confirmation'),
          html: `
            <div class='swal-customs-div'>
                <h5 class='swal-custom-title'>${this.translate.instant('COMMON.are-you-sure')}</h5>
                <p class='swal-custom-text'>${this.translate.instant('COMMON.wont-recover')}</p>
            </div>`,
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-danger',
            cancelButton: 'cancel-swal-custom btn btn-secondary'
          },
          cancelButtonText: `${this.translate.instant('COMMON.close')}`,
          confirmButtonText: this.translate.instant('COMMON.yes-delete')
        }).then(result => {
          return result.isConfirmed;  // Return true if confirmed, false otherwise
        });
    }

    createFormData(formElement: FormGroup | UntypedFormGroup){
        const formData = new FormData();
        Object.keys(formElement.controls).forEach(field => {
            formData.append(field, (formElement.get(field)?.value ?? "") );
        });

        return formData;
    }

    validateAvatar(event){
        const input = event.target as HTMLInputElement;
    
        if (input.files && input.files[0]) {
          const file = input.files[0];
          const maxSizeInMB = 3;
    
          // Validate file type
          const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
          if (!allowedTypes.includes(file.type)) {
            return [false, this.translate.instant('VALIDATION.avatar-type')];
          }
    
          // Validate file size
          if (file.size > maxSizeInMB * 1024 * 1024) {
            return [false, this.translate.instant('VALIDATION.avatar-size')];
          }

          return [true, file];

        }

        return [false, ""];
    }

    formatNumberNL(value: number | string | null | undefined): string {
        if (!value || isNaN(+value)) {
            return '0';
        }
    
        const number = Number(value);
        const hasFraction = number % 1 !== 0;

        const options: Intl.NumberFormatOptions = {
            minimumFractionDigits: hasFraction ? 2 : 0,
            maximumFractionDigits: 2,
            useGrouping: true
        };
    
        return new Intl.NumberFormat('nl-NL', options).format(number);
    }

    percentageAmount(amount: number | string | null | undefined, percentage: number | string | null | undefined){
        if (!amount || isNaN(+amount) || !percentage || isNaN(+percentage)) {
            return '0,00';
        }

        var result: any = (+amount / 100) * (+percentage);
        return this.formatNumberNL(result);
    }

    commaSeperatedString(array: string[]) : string {
        if (!Array.isArray(array)) return '-';
        const data = array
                        .map(item => (item ? item.trim() : ''))     // remove whitespace
                        .filter(item => item !== '')  // remove empty values
                        .join(', ')
                        .trim();

        return (data == "" ? "" : data);
    }

    clubTags: string[] = [
        "<club>",
        "<club-straat>",
        "<club-postcode>",
        "<club-plaats>",
        "<club-logo-url>"
    ];
      
    memberTags: string[] = [
        "<naam-lid>",
        "<voornaam-lid>",
        "<lidnummer>", 
        "<lid-straat>",
        "<lid-postcode>",
        "<lid-plaats>",
        "<lid-land>",
        "<e-mail>",
        "<telefoonnummer>"
    ];
    
    dossierTags: string[] = [
        "<dossier-id>",
        "<seizoen>",
        "<team>",
        "<totaal>",
        "<al-betaald>",
        "<openstaand-bedrag>",
        "<brief-datum>"
    ];

    workflowTags: string[] = [
        "<betaallink>",
        "<openstaand-bedrag-factuur>",
    ];

    workflowOtherTags: string[] = [
        "<totaal-aantal-termijnen>",
        "<workflow-startdatum>",
        "<termijnbetaling>",
        "<servicekosten>",
        "<totaal-eerste-termijn>"
    ]


    creatingExport: boolean = false;
    generateExport(downloadUrl, fileTitle, prependTitle=""){

        if(this.creatingExport === false){
            
            this.creatingExport = true;
            this.http.get(downloadUrl, {
                responseType: 'blob',
                withCredentials: true // if you're using Sanctum or cookies
            }).subscribe(blob => {
                const fileName = prependTitle + this.translateService.instant(fileTitle)+'.xlsx';
                const a = document.createElement('a');
                const objectUrl = URL.createObjectURL(blob);
                a.href = objectUrl;
                a.download = fileName;
                a.click();
                URL.revokeObjectURL(objectUrl); // cleanup
                this.creatingExport = false;
            }, error => {
                const msg = this.translateService.instant("ALERTS.failed-to-download-no-exist");
                this.alertService.triggerAlert(msg, "error");   
                this.creatingExport = false;
            });
        }
        

    }

    getSmaller(firstNum: number, secondNum: number){
        if(!firstNum)
            return secondNum;
        
        if(!secondNum)
            return firstNum;

        return (+firstNum < +secondNum) ? firstNum : secondNum;
    }

    getDaysFromToday(dateStr: string | null | undefined): number {

        if (!dateStr) return 0;

        // Normalize: turn "2025-03-01 14:30:00" → "2025-03-01T14:30:00"
        // And "2025-03-01" stays "2025-03-01"
        const normalized = dateStr.replace(' ', 'T');

        // Create JS Date (local timezone, no UTC conversion)
        const target = new Date(normalized);

        // Strip time from "today"
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        // Strip time if input had time part
        const targetMidnight = new Date(target.getFullYear(), target.getMonth(), target.getDate());

        const diffMs = today.getTime() - targetMidnight.getTime();
        var days = Math.round(diffMs / (1000 * 60 * 60 * 24));

        return days + 1;
    }
}

